import { lazy } from "react";

const Index = lazy(() => import("./Broadcast"));
const Create = lazy(() => import("./Create"));

export { Index, Create };
